// IMPORTACIÓN DE ICONOS FONT AWESOME PARA EL USO DINÁMICO EN TODO EL SISTEMA
import * as solidIcons from '@fortawesome/free-solid-svg-icons';
import * as brandIcons from '@fortawesome/free-brands-svg-icons';
export default { solidIcons, brandIcons };